import { ADD_BNG_PURPOSE, REMOVE_BNG_PURPOSE, GO_TO_BNG_LIST } from '../mainActionTypes';

export function togglePurpose (purpose, purposeList) {
  let included = false;
  if (purposeList && purposeList.includes(purpose)) {
    included = true;
  }
  let action = {};
  if (included) {
    action = { 
      type: REMOVE_BNG_PURPOSE,
      payload: { purpose }
    };
    
  } else {
    action = { 
      type: ADD_BNG_PURPOSE,
      payload: { purpose }
    };
    
  }
  return action;
}

export function goToNamesList() {
  let action = {};
  action = {
    type: GO_TO_BNG_LIST
  };
  return action;
}
  
